import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '../../config/environment.token';
import { Environment } from '../../../../environments/environment.model';
import { ApiResponse } from '../../../shared/types/api.type';
import { GroupTask, GroupTaskFilters } from './types/group-task.type';

@Injectable({ providedIn: 'root' })
export class GroupTasksService {
  private readonly http = inject(HttpClient);
  private readonly appConfig = inject(APP_CONFIG) as Environment;
  private readonly baseUrl = `${this.appConfig.apiUrl}/group-tasks`;

  readonly pendingCount = signal<number>(0);
  readonly total = signal<number>(0);

  refreshPendingCount(): void {
    this.countPending().subscribe({
      next: response => this.pendingCount.set(response.data?.count ?? 0),
      error: () => this.pendingCount.set(0),
    });
  }

  list(filters: GroupTaskFilters = {}): Observable<ApiResponse<GroupTask[]>> {
    let params = new HttpParams();

    if (filters.status) {
      params = params.set('status', filters.status);
    }
    if (filters.newNameSearch) {
      params = params.set('newNameSearch', filters.newNameSearch);
    }
    if (filters.previousNameSearch) {
      params = params.set('previousNameSearch', filters.previousNameSearch);
    }
    if (filters.dateFrom) {
      const dateFrom = new Date(filters.dateFrom);
      dateFrom.setHours(0, 0, 0, 0);
      params = params.set('dateFrom', dateFrom.toISOString());
    }
    if (filters.dateTo) {
      const dateTo = new Date(filters.dateTo);
      dateTo.setHours(23, 59, 59, 999);
      params = params.set('dateTo', dateTo.toISOString());
    }

    return this.http.get<ApiResponse<GroupTask[]>>(this.baseUrl, { params });
  }

  countPending(): Observable<ApiResponse<{ count: number }>> {
    return this.http.get<ApiResponse<{ count: number }>>(`${this.baseUrl}/pending-count`);
  }

  markDone(id: number): Observable<ApiResponse<GroupTask>> {
    return this.http.patch<ApiResponse<GroupTask>>(`${this.baseUrl}/${id}/mark-done`, {});
  }
}
